import styled from 'styled-components'

export type ConfirmationVariant = 'danger' | 'warning' | 'info' | 'success'

export const Container = styled.div<{ $autoWidth?: boolean }>(({ theme, $autoWidth }) => ({
  backgroundColor: theme.colors.white,
  borderRadius: theme.border.radius['8'],
  boxShadow: theme.shadow.xl,
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '90vh',
  maxWidth: $autoWidth ? '90vw' : '44rem',
  outline: 'none',
  overflow: 'hidden',
  width: $autoWidth ? 'auto' : '100%',
}))

export const Header = styled.div<{ $variant: ConfirmationVariant }>(({ theme, $variant }) => ({
  alignItems: 'center',
  backgroundColor: {
    danger: theme.colors.red500,
    info: 'transparent',
    success: theme.colors.green500,
    warning: theme.colors.orange500,
  }[$variant],
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.primary200}`,
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
  padding: `${theme.space['16']} ${theme.space['24']}`,
}))

export const HeaderTitle = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))

export const HeaderIcon = styled.div(({ theme }) => ({
  alignItems: 'center',
  color: theme.colors.black600,
  display: 'flex',
}))

export const HeaderText = styled.h2<{ $variant: ConfirmationVariant }>(({ theme, $variant }) => ({
  color: $variant === 'info' ? theme.colors.black800 : theme.colors.white,
  fontSize: '1.8rem',
  fontWeight: 500,
  lineHeight: '2.4rem',
  margin: 0,
}))

export const Body = styled.div(({ theme }) => ({
  color: theme.colors.black700,
  flex: 1,
  fontSize: '1.8rem',
  fontWeight: 500,
  lineHeight: '2.4rem',
  overflow: 'auto',
  padding: theme.space['24'],
}))

export const Footer = styled.div(({ theme }) => ({
  borderTop: `${theme.border.size['1']} solid ${theme.colors.primary200}`,
  display: 'flex',
  gap: theme.space['12'],
  justifyContent: 'flex-end',
  padding: `${theme.space['16']} ${theme.space['24']}`,
}))
